// GENERADO por scripts/gen-abi.mjs desde out/KeelReferidos.sol/KeelReferidos.json — no editar a mano.
// Se regenera en cada build; si algo no cuadra, corre `forge build` y `npm run abi`.

export const keelReferidosAbi = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_gobierno",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "_bps",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "MAX_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "activar",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "activo",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "altaEn",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "anotar",
    "inputs": [
      {
        "name": "tokenRef",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "valor",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "bloqueado",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "bpsReferido",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "consulta",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "referidor",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "bps",
        "type": "uint16",
        "internalType": "uint16"
      },
      {
        "name": "act",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "factoriaValida",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "generado",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "gobierno",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "minGenerado",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "referidorDe",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "registrar",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "referidor",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "caduca",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "firma",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "registrarPropio",
    "inputs": [
      {
        "name": "referidor",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setBloqueo",
    "inputs": [
      {
        "name": "referidor",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "valor",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setBps",
    "inputs": [
      {
        "name": "_bps",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setFactoria",
    "inputs": [
      {
        "name": "factoria",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "valida",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setGobierno",
    "inputs": [
      {
        "name": "_g",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setMinimo",
    "inputs": [
      {
        "name": "tokenRef",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "minimo",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "textoAFirmar",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "referidor",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "caduca",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "pure"
  },
  {
    "type": "event",
    "name": "Activado",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "referidor",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "tokenRef",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "acumulado",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Alta",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "referidor",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Bloqueo",
    "inputs": [
      {
        "name": "referidor",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "bloqueado",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BpsCambiado",
    "inputs": [
      {
        "name": "bps",
        "type": "uint16",
        "indexed": false,
        "internalType": "uint16"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "FactoriaCambiada",
    "inputs": [
      {
        "name": "factoria",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "valida",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Generado",
    "inputs": [
      {
        "name": "dueno",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "tokenRef",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "valor",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "acumulado",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "GobiernoCambiado",
    "inputs": [
      {
        "name": "gobierno",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "MinimoCambiado",
    "inputs": [
      {
        "name": "tokenRef",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "minimo",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "AutoReferido",
    "inputs": []
  },
  {
    "type": "error",
    "name": "BpsAlto",
    "inputs": []
  },
  {
    "type": "error",
    "name": "Cero",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FirmaCaducada",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FirmaInvalida",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoEsVault",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoGobierno",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ReferidorBloqueado",
    "inputs": []
  },
  {
    "type": "error",
    "name": "YaTieneReferidor",
    "inputs": []
  }
] as const;
